import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { SimulatorService } from 'src/app/simulator-booking/services/simulator.service';

@Component({
    selector: 'simulator-create-modal',
    templateUrl: './simulator-create-modal.component.html',
    styleUrl: './simulator-create-modal.component.scss',
    standalone: false
})
export class SimulatorCreateModalComponent extends BaseModalComponent{

  public form = new FormGroup({
    bayNumber: new FormControl(null,{
      validators: Validators.required
    }),
    bayName: new FormControl('',{
      validators: Validators.required
    }),
    capacity: new FormControl(6 ,{
      validators: Validators.required
    }),
    organizationId: new FormControl('',{
      validators: Validators.required
    }),
    createdBy: new FormControl(),
  });


  constructor(private sessionService: SessionService,
    private simulatorService: SimulatorService,
    public dialogRef: MatDialogRef<SimulatorCreateModalComponent>) {
    super();
    this.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);
    this.form.get('createdBy').setValue(this.sessionService.getUserId());
  }


  submit({value, valid}){
    if(valid){
      this.isLoading = true;
      value.isAvailable = true;
      this.simulatorService.create(value).subscribe({
        next: (result) => {
          if(result !== null || result !== undefined){
            this.dialogRef.close("save");
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.setError(error, this.form);
          console.error(error);
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
